import React, { ComponentState, useEffect, useState } from "react"
import SkeletonTypography from "../../../../../components/SkeletonTypography";
import { Modal, TablePagination } from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { MetaData } from "../../../../../dataModel/documentModels";
import { InboxRequestObj, MessageItem } from "../../../../../dataModel/messagesModal";
import trash from "../../../../../images/trash2.png"
// import vision from "../../../../../images/view.png"
import viewNew from "../../../../../images/viewNew.png"
import DeleteDialogModal from "../../../../../components/delete-dialog";
import { messages } from "../../../../../services/messageService";
import ViewMessage from "../inbox/inbox";
import attachment from "../../../../../images/attachment.png"
import { MessageCompose } from "./compose-message";
import { saveMessagesList, setMessageListToBack } from "../../../../../redux/actions";

export interface listProps {
    loadingState: boolean
    messageList: MessageItem[]
    metaObj?: MetaData
    requestObj: InboxRequestObj
    handleChangePage(event: any, newpage: number): void
    handleDeletedMessage(msg: MessageItem): void
    handleChangeRowsPerPage(event: any): void
    tabSelectionID: string
    tabId: number
    updateListViewMessageStatus(message:MessageItem):void
}

export const MessageItemComponent = (props: listProps) => {

    const {
        loadingState,
        messageList,
        metaObj,
        requestObj,
        tabSelectionID,
        tabId,
        handleChangePage,
        handleChangeRowsPerPage,
        handleDeletedMessage,
        
    } = props;
    const [confirm, setConfirm] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState<MessageItem>();
    const hideConfirmPopup = () => {
        setConfirm(!confirm)
    }
    const handleDelete = async () => {
        setConfirm(false)
        const deleteResp = await messages.deleteMessage({
            "messageReceiverId": [
                selectedMessage?.id
            ]
        })
        if (deleteResp && selectedMessage) {
            handleDeletedMessage(selectedMessage)
        }
    }
    const state: ComponentState = useSelector(states => {
        return states;
    });
    const { isChangeToList,messageCounter} = state['MessagesReducer'];
 
    
    const [showCompose, setShowCompose] = useState(false)
    const [isMessageDetail, setMessageDetail] = useState(false);
    const dispatch=useDispatch()
   
    useEffect(()=>{
        if(isChangeToList && isChangeToList>0){
            setMessageDetail(false)
            dispatch(setMessageListToBack(0))
        }
    },[isChangeToList])
    return (
        <div className="tab-pane" id={tabSelectionID} role="tabpanel">
            <Modal
                open={showCompose}
                onClose={() => { }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <MessageCompose onClose={() => setShowCompose(false)} title="Message" selectedMessage={selectedMessage} tabId={tabId}/>
            </Modal>

            {(loadingState) ? <SkeletonTypography /> :
                isMessageDetail ? <ViewMessage isInbox={tabId} onReplyMessage={() => { setShowCompose(true) }}
                    message={selectedMessage ? selectedMessage : {}} onClose={() => { setMessageDetail(false) }} /> :
                    <div className="col-lg-12 col-md-12 col-sm-12 overflowWidthScroll">
                        <table className="table messgaeTable mb-0">
                            <thead>
                                <tr>
                                    <th>{tabSelectionID === 'tabs-2' ? 'To' : 'From'}</th>
                                    <th>Date</th>
                                    <th>Subject</th>

                                    <th>Message</th>
                                    {<th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody style={{ padding: "auto 10px auto 10px" }}>
                                {
                                    messageList?.map((item: MessageItem) => {
                                        const unreadClass = (item.viewed === false && tabId===0) ? 'unread-message' : '';
                                        return (
                                            <tr >
                                                <td className={unreadClass}>{tabSelectionID === 'tabs-2' ? item.toStaffName : item.fromStaffName}</td>
                                                <td className={unreadClass}>{moment(item.utcDateCreated).format('MM/DD/YYYY')}</td>
                                                <td className={unreadClass}>{item.subject}
                                                    {(item.attachments && item.attachments.length > 0) &&
                                                        <center> <div className="d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                                                            <img src={attachment} style={{ width: 14, height: 14, resize: 'horizontal' }} />
                                                            <div className="small-text">{` (${item.attachments.length})`}</div>
                                                        </div></center>}


                                                </td>

                                                <td className={unreadClass} style={{ maxWidth: 100, overflow: 'hidden', textOverflow:'ellipsis' }} >{item.body}</td>
                                                <td><div>

                                                    <button className="iconBtn-bg" onClick={() => {
                                                        setSelectedMessage(item)
                                                        setMessageDetail(true)
                                                        props.updateListViewMessageStatus(item)
                                                    }}><img src={viewNew} alt="View" className="iconBtn-view" />
                                                    </button>

                                                    {tabSelectionID !== 'tabs-3' && <button className="ml-2" onClick={() => {
                                                        setSelectedMessage(item)
                                                        hideConfirmPopup()
                                                    }}><img src={trash} alt="" /></button>
                                                    }

                                                </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100, 500]}
                            component="div"
                            count={metaObj?.totalCount ?? 0}
                            rowsPerPage={requestObj.pageSize}
                            page={requestObj.currentPage - 1}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
            }
            {confirm && (
                <DeleteDialogModal
                    onClose={hideConfirmPopup}
                    title="Message"
                    message="message"
                    handleDelete={handleDelete}
                />
            )}
        </div>)
}